export default __webpack_public_path__ + "d9ccd58acdcd8839c6666bca51b30484.svg";